import backendV2Service from './backend-v2.service';

export interface NewDemoUser {
  firstname: string;
  lastname: string;
  identifier: string;
  baseCountryId: number;
  schoolId: number;
  courseId?: number;
}

export interface CreateDemoPayload {
  mode: 'reuse' | 'new';
  accountType: 0 | 2;
  startingDate: string;
  finishDate: string;
  client: string;
  reason?: string;
  bookUserId?: number;
  newUser?: NewDemoUser;
}

export interface CreateDemoResult {
  status: string;
  content: {
    activationCode: string;
    link: string;
    bookUserId: number;
    startingDate: string;
    finishDate: string;
  };
}

export interface DemoRow {
  id: number;
  client: string;
  reason: string;
  userId: number;
  creationDate: string;
  startingDate: string;
  finishDate: string;
  activationCode: string;
  loginCount: number;
  lastLoginAt: string | null;
  userType: number;
  firstname: string;
  lastname: string;
  dni: string;
  grade: string | null;
  country: string | null;
  school: string | null;
}

export interface DemoCandidate {
  id: number;
  name: string;
  grade: string | null;
  school: string;
  country: string | null;
}

export interface DemoOption {
  id: number;
  name: string;
}

export interface DemoCourse {
  id: number;
  grade: string | null;
}

const unwrap = <T>(req: Promise<{ data: T }>) => req.then(({ data }) => data);

export default {
  create: (payload: CreateDemoPayload): Promise<CreateDemoResult> => unwrap(
    backendV2Service.post<CreateDemoResult>('/demo-accounts', payload),
  ),

  list: (params?: { email?: string; page?: number; size?: number }): Promise<DemoRow[]> => unwrap(
    backendV2Service.get<DemoRow[]>('/demo-accounts', { params }),
  ),

  candidates: (params?: {
    countryId?: number;
    schoolId?: number;
    grade?: number;
    userType?: number;
  }): Promise<DemoCandidate[]> => unwrap(
    backendV2Service.get<DemoCandidate[]>('/demo-accounts/candidates', { params }),
  ),

  patch: (id: number, payload: { finishDate?: string; revoke?: boolean }) => unwrap(
    backendV2Service.patch(`/demo-accounts/${id}`, payload),
  ),

  countries: (): Promise<DemoOption[]> => unwrap(
    backendV2Service.get<DemoOption[]>('/demo-accounts/countries'),
  ),

  schools: (countryId?: number): Promise<DemoOption[]> => unwrap(
    backendV2Service.get<DemoOption[]>('/demo-accounts/schools', { params: { countryId } }),
  ),

  courses: (schoolId: number): Promise<DemoCourse[]> => unwrap(
    backendV2Service.get<DemoCourse[]>('/demo-accounts/courses', { params: { schoolId } }),
  ),
};
